import React, { useState } from "react";
import TextareaAutosize from 'react-textarea-autosize';

const ChatMessageInput = ({
  backgroundColor,
  handleAnswer,
  formdata,
  setformdata,
  handleKeyDown,

}) => {
  return (
    // <div className="absolute w-[100%] left-[50%] translate-x-[-50%]  top-[calc(100vh-270px)]" style={{padding:"40px 0px"}} >
    <div className={`absolute w-[100%] left-[50%] translate-x-[-50%]`} style={{padding:"34px 0px",bottom:`0px`,background:"white",paddingTop:'0px'}} >

    <div
        className={`bg-[${backgroundColor}] max-w-[885px] w-[95%] min-h-[65px] p-[15px] rounded-[10px] flex mx-auto`}
>
       <TextareaAutosize
        value={formdata.query}
        onChange={(e) =>
          setformdata((prev) => ({
            ...prev,
            query: e.target.value,
          }))
        }
        onKeyDown={handleKeyDown}

        placeholder="Enter a prompt here"
        className="w-full bg-transparent max-h-32 focus:ring-0 focus:outline-none text-[#2C2C2C] placeholder-[#2C2C2C] pt-[3px]"
      />
      {formdata?.query?.length > 0 && (
        <div
          onClick={() => handleAnswer()}
          className="submit-icon w-[40px] ml-1  aspect-square rounded-[5px] flex items-center justify-center cursor-pointer"
        >
          <img src="./assets/images/submit-i.png" alt="submit-icon" />
        </div>
      )}
    </div>
    </div>
  );
};

export default ChatMessageInput;
